import React, {useContext} from "react";
import {PolymorphicItem, isDelivery} from "../../tevapi/interfaces";
import {Select, Space, Spin, Tooltip} from "antd";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ComparingItemContext, ItemRelationTypes} from "../../contexts/items";
import {SelectProps} from "antd/es/select";


const labelFromItem = (item: PolymorphicItem): string => {
  const itemType = isDelivery(item) ? item.unique_for?.name : "Atlas";

  const itemName = "host_star" in item ? `${item.host_star.slug}: ${item.slug}` : item.slug.toString();

  return `${itemType} | ${itemName}`;
};

interface ICompareInterface {
  referenceItem: PolymorphicItem;
};


export const CompareSelect: React.FC<ICompareInterface> = ({referenceItem}) => {

  const context = useContext(ComparingItemContext);

  if (context === null || context.relationsLoading) {
    return <Spin />;
  }

  const keys: ItemRelationTypes[] = ["siblings", "delivery_siblings", "sources"];
  const aliases = {
    siblings: "Siblings",
    delivery_siblings: "Delivery Siblings",
    sources: "Sources",
  };
  const options: SelectProps["options"] = [];

  keys.map(
    (key) => {
      const group = context.relationContext[key];
      if (group.length > 0) {
        options.push({
          label: aliases[key],
          title: key,
          key: key,
          options: group.map(
            (item) => {
              return {
                label: labelFromItem(item),
                key: item.pk,
                value: item.pk,
              };
            }
          ),
        });
      }
    }
  );

  if (context.relationContext.assigned_atlas) {
    const atlas = context.relationContext.assigned_atlas;
    options.unshift({
      label: "Assigned Atlas",
      title: "atlas",
      key: "atlas",
      options: [{
        label: labelFromItem(atlas),
        key: atlas.pk,
        value: atlas.pk
      }]
    });
  }
  return (
    <Space size="small">
      <Select
        options={options}
        value={context.comparison?.pk}
        onChange={context.setComparing}
        placeholder="Select comparison..."
        optionLabelProp="label"
        disabled={context.relationsLoading}
      />
      {
        context.comparison ?
       <Link
          to={`/items/${context.comparison.pk}/`}
          target="_blank"
        >
          <Tooltip title="Go to target in new tab">
            <FontAwesomeIcon
              icon="fa-regular fa-arrow-up-right-from-square"
            />
          </Tooltip>
        </Link> :
        null
      }
    </Space>
  );
};
